module.exports = __webpack_public_path__ + "static/media/JD-Advising_Logo.de8cfe95.svg";